enum MarkerSize {
  LARGE = "large",
  SMALL = "small",
}

export default MarkerSize;
